import { Currency } from '@/core/currency/interfaces';

const KMF: Currency = {
    name: 'Comorian Franc',
    demonym: 'Comorian',
    majorSingle: 'Franc',
    majorPlural: 'Francs',
    codeNumeric: '174',
    symbol: 'CF',
    symbolNative: 'CF',
    minorSingle: 'Centime',
    minorPlural: 'Centimes',
    ISOdigits: 0,
    decimals: 0,
    numToBasic: 100,
    code: 'KMF',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default KMF;
